import { useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'
import { useFormatDate } from '@/shared/lib'
import { Description } from '@/shared/ui'

export type Props = {
  week: number
  startDate: string
  endDate: string
}

const DATE_FORMAT = 'yyyy년 MM월 dd일'

export const ContractPeriod = ({ week, startDate, endDate }: Props) => {
  const t = useTranslations()
  const { formatDateWithDayOfWeek } = useFormatDate()

  return (
    <Card.Item>
      <Card.ItemTitle>{t('lease.lease_period.title')}</Card.ItemTitle>
      <Card.ItemContent>
        <p className="typo-body1 mb-2 block font-semibold text-purple-500">
          {t('common.week', { week })}
        </p>
        <Description.List>
          <Description.Item
            label={t('common.move_in')}
            value={formatDateWithDayOfWeek({
              date: startDate,
              format: DATE_FORMAT,
            })}
          >
            <Description.ItemLabel className="min-w-18">
              {t('common.move_in')}
            </Description.ItemLabel>
            <Description.ItemValue>
              {formatDateWithDayOfWeek({
                date: startDate,
                format: DATE_FORMAT,
              })}
            </Description.ItemValue>
          </Description.Item>
          <Description.Item>
            <Description.ItemLabel className="min-w-18">
              {t('common.move_out')}
            </Description.ItemLabel>
            <Description.ItemValue>
              {formatDateWithDayOfWeek({
                date: endDate,
                format: DATE_FORMAT,
              })}
            </Description.ItemValue>
          </Description.Item>
        </Description.List>
      </Card.ItemContent>
    </Card.Item>
  )
}
